import { sanitizePassagemUserCopy } from "./passagemDisplayCopy";

const SCENARIO_COLORS = {
  link_not_accessed: "default",
  link_expired: "warning",
  payment_rejected: "error",
  payment_pending: "info",
  payment_approved: "success",
  api_error: "warning",
};

function cleanPaymentIntentCopy(text) {
  return sanitizePassagemUserCopy(text);
}

export function paymentIntentChipColor(scenario) {
  return SCENARIO_COLORS[String(scenario || "").toLowerCase()] || "default";
}

export function paymentIntentDisplayLabel(intent) {
  const cleaned = cleanPaymentIntentCopy(intent?.label);
  if (cleaned) return cleaned;
  if (String(intent?.scenario || "").toLowerCase() === "payment_approved") {
    return "Pagamento aprovado";
  }
  return intent?.label || "";
}

export function paymentIntentDisplaySummary(intent) {
  return cleanPaymentIntentCopy(intent?.summary);
}

export function paymentIntentTooltip(intent) {
  if (!intent) return "";
  const parts = [];
  const summary = cleanPaymentIntentCopy(intent.summary);
  if (summary) parts.push(summary);
  if (intent.statusDetailLabel) parts.push(`Motivo: ${intent.statusDetailLabel}`);
  if (intent.attemptsCount > 0) parts.push(`${intent.attemptsCount} tentativa(s) via XPay`);
  if (intent.preferenceExpired) parts.push("Link expirado");
  return parts.join(" · ");
}
